// constants.js
export const ROAD_ADMINISTRATORS = {
  REGION: "REGION",
  AUDERGHEM: "AUDERGHEM",
  ANDERLECHT: "ANDERLECHT",
  JETTE: "JETTE",
  BERCHEM_SAINTE_AGATHE: "BERCHEM_SAINTE_AGATHE",
  EVERE: "EVERE",
  ETTERBEEK: "ETTERBEEK",
  KOEKELBERG: "KOEKELBERG",
  SCHAERBEEK: "SCHAERBEEK",
  VILLE_DE_BRUXELLES: "VILLE_DE_BRUXELLES",
  FOREST: "FOREST",
  MOLENBEEK_SAINT_JEAN: "MOLENBEEK_SAINT_JEAN",
  UCCLE: "UCCLE",
  GANSHOREN: "GANSHOREN",
  SAINT_GILLES: "SAINT_GILLES",
  WATERMAEL_BOITSFORT: "WATERMAEL_BOITSFORT",
  IXELLES: "IXELLES",
  SAINT_JOSSE_TEN_NOODE: "SAINT_JOSSE_TEN_NOODE",
  WOLUWE_SAINT_LAMBERT: "WOLUWE_SAINT_LAMBERT",
  WOLUWE_SAINT_PIERRE: "WOLUWE_SAINT_PIERRE"
};